import View from '~/app/View'

import FeaturedArticles from '~/components/blog/featured-articles'

import ArticleCard from '~/components/blog/article-card'

import '@/templates/blog.scss'

const pageView = new View()
pageView.init({
  FeaturedArticles,
  ArticleCard,
})
